import { type ButtonHTMLAttributes, type DetailedHTMLProps, forwardRef } from 'react'
import classes from './button.module.css'

type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function ButtonComp(props, ref) {
  const { className, ...otherProps } = props

  const cls = `${className} ${classes.root}`

  return <button type="button" {...otherProps} className={cls} ref={ref} />
})
